import React from 'react'
import IsViewport from './IsViewport'
import PropTypes from 'prop-types'
import objectAssign from 'object-assign'

const types = IsViewport.mappings.map(([propName]) => propName)
function typeHelper (currentType) {
  function TypeHelper (props) {
    const newProps = objectAssign(
      {},
      props,
      types.reduce(
        (typeMap, type) =>
          objectAssign({}, typeMap, {
            [type]: props.invert ? type !== currentType : type === currentType
          }),
        {}
      )
    )

    return <IsViewport {...newProps} />
  }
  TypeHelper.propTypes = {
    invert: PropTypes.bool
  }

  return TypeHelper
}

export default typeHelper
